module.exports = __webpack_public_path__ + "img/Back.7eb15a49.svg";